const isNumber = (value) => typeof value === 'number';

export { isNumber };
//# sourceMappingURL=isNumber.js.map
